import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { CupcakeDropdownsModule } from '@ipreo/cupcake-components';
import { SharedModule } from '@ipreo/muni-shared';
import { MonitorPriorityPageComponent } from './components/tabs/monitor-priority-tab/monitor-priority-page.component';
import { MonitorRetailPageComponent } from './components/tabs/monitor-retail-tab/monitor-retail-page.component';
import { MonitorOverviewPageComponent } from './components/tabs/monitor-overview-tab/monitor-overview-page.component';
import { RadioSelectorComponent } from './components/filter-label/radio-selector/radio-selector.component';
import { FilterLabelComponent } from './components/filter-label/filter-label.component';
import { MonitorComponent } from './components/monitor/monitor.component';
import { TrancheModule } from '../tranche/Tranche.module';
import { GamedaySharedModule } from '../shared/shared.module';

export const agGridModule = AgGridModule.withComponents([]);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TrancheModule,
    CupcakeDropdownsModule,
    SharedModule,
    agGridModule,
    GamedaySharedModule,
  ],
  declarations: [
    MonitorComponent,
    MonitorOverviewPageComponent,
    MonitorRetailPageComponent,
    MonitorPriorityPageComponent,
    FilterLabelComponent,
    RadioSelectorComponent,
  ],
  exports: [MonitorComponent],
})
export class MonitorModule {}
